import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  Grid,
  makeStyles,
  Typography,
  CssBaseline,
  Button,
  IconButton,
  MenuItem,
  InputAdornment,
  Box,
  Checkbox,
  FormControl,
  FormHelperText,
} from "@material-ui/core";
import { useHistory, Link } from "react-router-dom";
import { validarRUT } from "validar-rut";
import MaskedInput from "react-text-mask";
import { TextField, Paper, Loader, PopUp, TextField1 } from "../components";
import { FormValidator, onBlur, formatDate } from "../helpers";
import { ArrowBackIcon, ShowIcon } from "../icons";
import { doctorServices, labServices } from "../services";
import { modals } from "../constants";
import { TextField as CustomTextField } from "@material-ui/core";
import { AuthContext } from "../context";
import { PASSWORD_REGEX, getPasswordStrength, getPasswordStrengthColor, getPasswordStrengthText, getVerificationMessage } from "../helpers/passwordValidator";
// [CAPTCHA] import ReCAPTCHA from "react-google-recaptcha";
export default function Login(props) {
  const classes = useStyles(props)();
  const [rut, setRut] = useState("");
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [specialty, setSpecialty] = useState("N");
  const [subSpecialty, setSubSpecialty] = useState("N");
  const [phone, setPhone] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("N");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [specialtiesList, setSpecialtiesList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalError, setModalError] = useState(false);
  //const location = useLocation();
  const history = useHistory();
  const [termsAndCond, setTermsAndCond] = useState(false);
  const [lastTermAndCond, setLastTermAndCond] = useState(null);
  const { signIn } = useContext(AuthContext);
  // [CAPTCHA] const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  // [CAPTCHA] const captchaRef = useRef(null);

  // [CAPTCHA]
  // const captchaOnChange = (value) => {
  //   if (value) {
  //     setIsCaptchaVerified(true);
  //   } else {
  //     setIsCaptchaVerified(false);
  //   }
  // };
  useEffect(() => {
    async function init() {
      try {
        const { status, response } = await doctorServices.getSpecialties();
        if (status === 200) {
          setSpecialtiesList(response.specialties);
          //console.log({response})
        }
      } catch (e) {}
    }
    init();
  }, []);
  useEffect(() => {
    async function init() {
      try {
        const { status, response } = await labServices.getLastConsentVersion({
          owner: "UNIO",
          target: "DOCTORS",
          type: "REGISTER",
        });
        if (status === 200) {
          setLastTermAndCond(response);
          // console.log({response})
        }
      } catch (e) {}
    }
    init();
  }, []);

  const setNewBDay = (val) => {
    // console.log({ val });
    //let nbday = new Date(moment(val).format("YYYY-MM-DD"));
    // console.log("formato pasado", val);
    //console.log("formato ideal", nbday)
    setBirthDate(val);
  };

  const validatorStep2 = new FormValidator([
    {
      field: "specialty",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese su especialidad.",
    },
    // {
    //   field: "subSpecialty",
    //   method: "isEmpty",
    //   validWhen: false,
    //   message: "Ingrese su Sub - Especialidad.",
    // },
    // {
    //   field: "birthDate",
    //   method: "isEmpty",
    //   validWhen: false,
    //   message: "Ingrese su fecha de nacimiento.",
    // },
    {
      field: "year",
      method: (year) => {
        return year.length < 4;
      },
      validWhen: false,
      message: "Año debe tener 4 caracteres.",
    },
    {
      field: "year",
      method: (year) => {
        // console.log({ year });
        const actually_year = new Date().getFullYear();
        return year < actually_year - 18 && year > actually_year - 80;
      },
      validWhen: true,
      message: "Ingrese un año valido.",
    },
    {
      field: "gender",
      method: "isEmpty",
      validWhen: false,
      message: "Seleccione un género.",
    },
    {
      field: "password",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese una contraseña.",
    },
    {
      field: "password",
      method: (password) => PASSWORD_REGEX.test(password),
      validWhen: true,
      message: (password) => getVerificationMessage(password),
    },
    {
      field: "confirm",
      method: "isEmpty",
      validWhen: false,
      message: "Confirme su contraseña.",
    },
    {
      field: "confirm",
      method: (confirm) => (confirm === password ? true : false),
      validWhen: true,
      message: "Las contraseñas no coinciden.",
    },
  ]);

  const onSubmit = async () => {
    if (!step) {
      const validation = validator.validate({
        name,
        lastName,
        email,
        rut: `${rut.split("-")[0]}${rut.split("-")[1]}`,
        phone,
      });
      setErrors(validation);
      if (validation.isValid) {
        setStep(1);
        return;
      }
    } else {
      const validationStep2 = validatorStep2.validate({
        year: birthDate,
        gender: gender === "N" ? "" : gender,
        password,
        confirm,
        specialty: specialty === "N" ? "" : specialty,
        subSpecialty: subSpecialty === "N" ? "" : subSpecialty,
      });
      setErrors(validationStep2);
      if (validationStep2.isValid) {
        // let formatedDate = formatDate(new Date(birthDate));
        // formatedDate = formatedDate.split("/");
        // formatedDate = `${formatedDate[2]}-${formatedDate[1]}-${formatedDate[0]}`;
        const userDoctor = {
          email,
          password,
          doctor: {
            rut: `${rut.split("-")[0]}${rut.split("-")[1]}`,
            gender,
            name,
            lastName,
            birthdate: birthDate,
            phone,
            specialties:
              subSpecialty === "N"
                ? [
                    {
                      name: specialtiesList.find((obj) => obj._id === specialty)
                        .name,
                      _id: specialty,
                    },
                  ]
                : [
                    {
                      name: specialtiesList.find((obj) => obj._id === specialty)
                        .name,
                      _id: specialty,
                    },
                    {
                      name: specialtiesList.find(
                        (obj) => obj._id === subSpecialty
                      )?.name,
                      _id: subSpecialty,
                    },
                  ],
          },
        };
        if (!termsAndCond) return;
        try {
          setLoading(true);
          //console.log("doctor:::",userDoctor)
          const { status, response } = await doctorServices.addUserDoctor({
            data: userDoctor,
          });
          // console.log({status, response})
          setLoading(false);
          if (status === 200) {
            if (response.error) {
              setModalMessage(response.error.message);
              setModalError(true);
              setModal(true);
            }
          }
          if (status === 201) {
            if (response.isPromo) {
              // signIn({
              //   token: response.user.token,
              //   user: response.user,
              //   doctor: response.doctor,
              // });
            }
            setModalMessage(response.message);
            setModalError(false);
            setModal(true);
          }
          if (status === 400) {
            if (response.error) {
              //console.log(response.error.message)
              setModalMessage(response.error.message);
              setModalError(true);
              setModal(true);
            }
          }
          if (status === 429) {
            setModalMessage("Se ha excedido el límite de registros al día");
            setModalError(true);
            setModal(true);
          }
        } catch (e) {
          setLoading(false);
          console.log("Error", e);
        }
      }
    }
  };

  const onGoBack = () => {
    if (!step) {
      history.goBack();
    } else {
      setStep(0);
    }
  };

  const validator = new FormValidator([
    {
      field: "rut",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese su Rut.",
    },
    {
      field: "rut",
      method: (rut) => validarRUT(rut),
      validWhen: true,
      message: "Rut invalido.",
    },
    {
      field: "name",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese su nombre.",
    },
    {
      field: "lastName",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese sus apellidos.",
    },
    {
      field: "email",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese correo electronico.",
    },
    {
      field: "email",
      method: "isEmail",
      validWhen: true,
      message: "Correo electronico invalido.",
    },
    {
      field: "phone",
      method: "isEmpty",
      validWhen: false,
      message: "Ingrese su numero de telefono.",
    },
  ]);

  //validate rut

  const onChangeRut = async (e) => {
    setRut(e.target.value);
    if (e.target.value.length >= 8) {
      setErrors(
        await onBlur({ field: "rut", value: e.target.value, validator, errors })
      );
    }
  };

  const renderStep = () => {
    switch (step) {
      case 0:
        return (
          <>
            <Grid item md={6} xs={12}>
              <TextField
                name={"name"}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Nombre *"
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "name",
                      value: name,
                      validator,
                      errors,
                    })
                  )
                }
                error={errors.name && errors.name.isInvalid}
                helperText={errors.name ? errors.name.message : ""}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                name={"lastName"}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                placeholder="Apellidos *"
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "lastName",
                      value: lastName,
                      validator,
                      errors,
                    })
                  )
                }
                error={errors.lastName && errors.lastName.isInvalid}
                helperText={errors.lastName ? errors.lastName.message : ""}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                name={"email"}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Correo *"
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "email",
                      value: email,
                      validator,
                      errors,
                    })
                  )
                }
                error={errors.email && errors.email.isInvalid}
                helperText={errors.email ? errors.email.message : ""}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                name={"rut"}
                placeholder="Rut *"
                value={rut}
                onChange={onChangeRut}
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "rut",
                      value: rut,
                      validator,
                      errors,
                    })
                  )
                }
                error={errors.rut && errors.rut.isInvalid}
                helperText={errors.rut ? errors.rut.message : ""}
                inputComponent={TextMaskCustom}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <CustomTextField
                name={"phone"}
                value={phone}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      style={{ marginLeft: "18px" }}
                    >
                      +56
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                  style: {
                    border: "1pt solid rgb(178, 178, 178)",
                    height: "43px",
                    margin: "0px 18px",
                    fontSize: "12px",
                    background: "rgb(255, 255, 255)",
                    boxShadow: "unset",
                    boxSizing: "unset",
                    fontWeight: "unset",
                    borderRadius: "25px",
                    alignSelf: "center",
                    color: "rgb(25, 42, 127)",
                  },
                  inputProps: {
                    style: {
                      height: "100%",
                      boxSizing: "border-box",
                    },
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    maxLength: 9,
                  },
                  classes: {
                    root: "custom-root-class",
                    error: "custom-error-class",
                  },
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  // Eliminar cualquier carácter que no sea un número
                  const cleanedValue = value.replace(/\D/g, "");

                  // Actualizar el estado solo si el valor es un número y tiene 9 dígitos
                  if (!isNaN(cleanedValue) && cleanedValue.length <= 10) {
                    setPhone(cleanedValue);
                  }
                }}
                placeholder="Telefono *"
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "phone",
                      value: phone,
                      validator,
                      errors,
                    })
                  )
                }
                error={errors.phone && errors.phone.isInvalid}
                helperText={errors.phone ? errors.phone.message : ""}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography className={classes.confirmText} color="secondary">
                Necesitamos confirmar que usted realmente es un médico, por eso
                esta información es muy valiosa para nosotros
              </Typography>
            </Grid>
          </>
        );
      case 1:
        return (
          <>
            <Grid item md={6} xs={12}>
              <TextField
                name={"specialty"}
                select
                value={specialty}
                onChange={(e) => setSpecialty(e.target.value)}
                placeholder="Especialidad *"
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "specialty",
                      value: specialty,
                      validator: validatorStep2,
                      errors,
                    })
                  )
                }
                error={errors.specialty && errors.specialty.isInvalid}
                helperText={errors.specialty ? errors.specialty.message : ""}
              >
                <MenuItem value={"N"} disabled={true}>
                  Especialidad
                </MenuItem>
                {specialtiesList.map((element, index) => (
                  <MenuItem key={index} value={element._id}>
                    {element.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            {/* <Grid item md={6} xs={12}>
              <TextField
                name={"sub-specialty"}
                select
                value={subSpecialty}
                disabled={specialty === "N"}
                placeholder="Sub - Especialidad *"
                onChange={(e) => setSubSpecialty(e.target.value)}
                onBlur={async () => setErrors(await onBlur({ field: "subSpecialty", value: subSpecialty, validator: validatorStep2, errors }))}
                error={errors.subSpecialty && errors.subSpecialty.isInvalid}
                helperText={errors.subSpecialty ? errors.subSpecialty.message : ""}
              >
                <MenuItem value={"N"} disabled={true}>
                  Sub - especialidad
                </MenuItem>
                {specialtiesList
                  .filter((value) => value._id !== specialty)
                  .map((element, index) => (
                    <MenuItem key={index} value={element._id}>
                      {element.name}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid> */}
            {/* <Grid item md={6} xs={7}>
              <TextField
                value={birthDate === "" ? null : birthDate}
                type={"date"}
                placeholder="Fecha de nacimiento *"
                onChange={(date) => setBirthDate(date)}
                maxDate={new Date()}
                minDate={new Date("01-01-1920")}
                onBlur={() => { }}
                format="MM/dd/yyyy"
                error={errors.birthDate && errors.birthDate.isInvalid}
                helperText={errors.birthDate ? errors.birthDate.message : ""}
              />
            </Grid> */}

            <Grid item md={6} xs={12}>
              {/* <TextField1
                select
                size="small"
                // inputRef={register({
                //   required: "Validez requerida",
                // })}
              /> */}
              <TextField
                value={birthDate}
                label="Año de nacimiento"
                placeholder="Año de nacimiento"
                name={"year"}
                type="number"
                onChange={(e) =>
                  e.target.value.length <= 4 && setNewBDay(e.target.value)
                }
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "year",
                      value: birthDate,
                      validator,
                      errors,
                    })
                  )
                }
                error={errors.year && errors.year.isInvalid}
                helperText={errors.year ? errors.year.message : ""}
              />
              {/* <DatePicker
                label="Año de nacimiento"
                color="secondary"
                inputVariant="outlined"
                placeholder="Fecha de nacimiento"
                onChange={(e) => setNewBDay(e.getFullYear())}
                value={birthDate && new Date(`01-01-${birthDate}`)}
                fullWidth
                variant="inline"
                size="small"
                views={["year"]}
                format="yyyy"
                minDate={new Date(new Date(`01-01-${new Date().getFullYear() - 80}`))}
                maxDate={new Date(new Date().setYear(new Date().getFullYear() - 18))}
              /> */}
            </Grid>

            <Grid item md={6} xs={12}>
              <TextField
                type={showPassword ? "text" : "password"}
                name={"password"}
                value={password}
                iconComponent={() => <ShowIcon />}
                onClickIcon={() => setShowPassword(!showPassword)}
                onChange={async (e) => {
                  setPassword(e.target.value);
                  setErrors(
                    await onBlur({
                      field: "password",
                      value: e.target.value,
                      validator: validatorStep2,
                      errors,
                    })
                  );
                }}
                placeholder="Contraseña *"
                style={{ justifyContent: "flex-end" }}
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "password",
                      value: password,
                      validator: validatorStep2,
                      errors,
                    })
                  )
                }
                error={errors.password && errors.password.isInvalid}
                helperText={errors.password ? errors.password.message : ""}
              />
               {password && (
                  <Box style={{ width: '100%', marginTop: '5px' }}>
                      <div style={{
                        height: '5px',
                        width: '100%',
                        backgroundColor: '#e0e0e0',
                        borderRadius: '5px',
                        overflow: 'hidden'
                      }}>
                        <div style={{
                          height: '100%',
                          width: `${(getPasswordStrength(password) / 4) * 100}%`,
                          backgroundColor: getPasswordStrengthColor(getPasswordStrength(password)),
                          transition: 'width 0.3s ease-in-out'
                        }} />
                      </div>
                      <Typography variant="caption" style={{ color: getPasswordStrengthColor(getPasswordStrength(password)) }}>
                        Fortaleza: {getPasswordStrengthText(getPasswordStrength(password))}
                      </Typography>
                  </Box>
                )}
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                name={"confirm"}
                type={showPassword ? "text" : "password"}
                fullWidth
                value={confirm}
                iconComponent={() => <ShowIcon />}
                onClickIcon={() => setShowPassword(!showPassword)}
                onChange={async (e) => {
                  setConfirm(e.target.value);
                  setErrors(
                    await onBlur({
                      field: "confirm",
                      value: e.target.value,
                      validator: validatorStep2,
                      errors,
                    })
                  );
                }}
                placeholder="Confirmar contraseña *"
                style={{ justifyContent: "flex-end" }}
                onBlur={async () =>
                  setErrors(
                    await onBlur({
                      field: "confirm",
                      value: confirm,
                      validator: validatorStep2,
                      errors,
                    })
                  )
                }
                error={errors.confirm && errors.confirm.isInvalid}
                helperText={errors.confirm ? errors.confirm.message : ""}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Typography style={{ color: "#192A7F", fontSize: "0.9rem" }}>
                {" "}
                Seleccione su género:{" "}
              </Typography>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant={gender === "MASCULINO" ? "contained" : "outlined"}
                  color="primary"
                  onClick={() => setGender("MASCULINO")}
                  style={{ width: "48%", borderRadius: "25px" }}
                >
                  Masculino
                </Button>
                <Button
                  variant={gender === "FEMENINO" ? "contained" : "outlined"}
                  color="primary"
                  onClick={() => setGender("FEMENINO")}
                  style={{ width: "48%", borderRadius: "25px" }}
                >
                  Femenino
                </Button>
              </div>
              {errors.gender && errors.gender.isInvalid && (
                <div style={{ color: "red" }}>{errors.gender.message}</div>
              )}
            </Grid>
            <Grid item md={12} xs={12} id="checkbox" style={{ paddingTop: 0, paddingBottom: 0 }}>
              <Box
                display={"flex"}
                style={{ flexDirection: "column", alignItems: "center" }}
              >
                <FormControl>
                  <Box
                    display={"flex"}
                    style={{ gap: 2, alignItems: "center" }}
                  >
                    <Checkbox
                      id="terms-and-conditions"
                      checked={termsAndCond}
                      onChange={(e) => setTermsAndCond(e.target.checked)}
                    />
                    <Typography
                      component={"label"}
                      htmlFor="terms-and-conditions"
                    >
                      Acepto los{" "}
                      <Typography
                        component={"a"}
                        href={lastTermAndCond?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        color="textPrimary"
                      >
                        Términos y condiciones
                      </Typography>
                    </Typography>
                  </Box>
                  {!termsAndCond && (
                    <FormHelperText
                      error={!termsAndCond}
                      style={{ textAlign: "center", marginTop: -8 }}
                    >
                      Debe aceptar los terminos y condiciones
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
            </Grid>
            {/* [CAPTCHA]
            <Grid item md={12} xs={12} style={{ display: "flex", justifyContent: "center", paddingTop: 4 }}>
              <ReCAPTCHA
                ref={captchaRef}
                sitekey="6Lcz_FkrAAAAAO9wXBX9Ft6ls16EaYzC6hKhwCBr"
                onChange={captchaOnChange}
              />
            </Grid>
            */}
          </>
        );
      default:
        return null;
    }
  };

  const onCloseModal = () => {
    setModal(!modal);
    if (!modalError) {
      history.push("/login");
    }
  };

  return (
    <Grid container alignItems="flex-end">
      <Loader loading={loading} />
      <PopUp
        open={modal}
        setModal={onCloseModal}
        modalName={modals[2]}
        modalError={modalError}
        // message={modalMessage}
        message={modalError ? modalMessage : ""}
        modalSubMessage={
          "Completado. Se ha enviado un correo de verificación a su email. Por favor, verifique su cuenta para poder iniciar sesión. Recuerde que en caso de no estar en el registro nacional de prestadores individuales de salud no podrá tener acceso a nuestra plataforma."
        }
      />
      <Container className={classes.container} component="main" maxWidth="md">
        <CssBaseline />
        <Grid
          container
          style={{ padding: "35px 0 35px", position: "relative" }}
          justify="center"
          alignItems="center"
        >
          <img src="../../assets/logo/logo-unio.png" alt="" />
          <IconButton
            style={{ position: "absolute", top: "8%", left: "5%" }}
            onClick={onGoBack}
          >
            <ArrowBackIcon />
          </IconButton>
        </Grid>
        <Paper>
          <Grid container style={{ paddingTop: 0}}>
            <Grid
              container
              spacing={3}
              className={classes.form}
              justify="center"
            >
              <Grid item md={12} xs={12}>
                <Typography component="h1" variant="h1" align="center" >
                  Registro
                </Typography>
              </Grid>
              {renderStep()}
              <Grid item md={8} xs={12} container justifyContent="center">
                <Button className={classes.button} onClick={onSubmit} disabled={false} /* [CAPTCHA] disabled={step === 1 && !isCaptchaVerified} */>
                  {!step ? "Continuar" : "Registrarse"}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Grid>
  );
}

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  const { value } = other;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={
        value.length <= 8
          ? [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /[kK0-9]/, /[kK0-9]/]
          : value.length <= 9
          ? [
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              "-",
              /[kK0-9]/,
              /[kK0-9]/,
            ]
          : [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /[kK0-9]+/g]
      }
      placeholderChar={"\u2000"}
      placeholder="Rut *"
      guide={false}
      showMask
    />
  );
}

const useStyles = (props) =>
  makeStyles((theme) => ({
    container: {
      [theme.breakpoints.down("xs")]: {
        padding: 0,
      },
      [theme.breakpoints.up("md")]: {
        overflowY: "auto",
        height: "100vh",
      },
      overflowY: "scroll",
      height: "calc(100vh - env(safe-area-inset-bottom, 0px))",
      '@supports (height: 100dvh)': {
        height: '100dvh',
      },
      paddingBottom: 'env(safe-area-inset-bottom, 20px)',
    },
    form: {
      width: "100%", // Fix IE 11 issue.
      margin: 0,
      [theme.breakpoints.up("md")]: {
        "& > div:nth-child(1)": {
          "& h1": {
            fontSize: "1.125rem",
            lineHeight: "1.375",
          },
        },
      },
      "& p:nth-child(7)": {
        margin: "25px 0 0 0",
        fontSize: "0.875rem",
        lineHeight: "1.063rem",
      },
    },
    paper: {
      boxSizing: "border-box",
      borderRadius: "45px 45px 0 0",
      boxShadow: "0px -3px 5px #D6D6D6BF",
      padding: 40,
      [theme.breakpoints.down("xs")]: {
        padding: 25,
      },
    },
    colorText: {
      fontWeight: "500",
      fontSize: "1rem",
      lineHeight: "1.125rem",
      letterSpacing: "0.05em",
      [theme.breakpoints.down("xs")]: {
        fontSize: "0.75rem",
        lineHeight: "0.914rem",
        margin: "20px 0 0 0",
      },
    },
    button: {
      backgroundColor: theme.palette.secondary.main,
      fontSize: "1.313rem",
      lineHeight: "1.508rem",
      letterSpacing: " 0.05em",
      color: "#FFFFFF",
      borderRadius: 30,
      fontWeight: "700",
      width: "80%",
      height: 40,
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
      },
      [theme.breakpoints.down("xs")]: {
        height: 41,
        fontSize: "1.125rem",
        lineHeight: "1.371rem",
      },
      [theme.breakpoints.up("md")]: {
        // margin: "30px 0 0 0",
        fontSize: "1.125rem",
        lineHeight: "1.375rem",
      },
    },
    lineDecoration: {
      margin: "30px 0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      width: "100%",
      "&:before": {
        width: 40,
        border: "2pt solid #C4C4C4",
        content: "' '",
        position: "absolute",
        left: 0,
        borderLeft: 0,
        borderRight: 0,
        borderTop: 0,
      },
      "&:after": {
        width: 40,
        border: "2pt solid #C4C4C4",
        content: "' '",
        position: "absolute",
        right: 0,
        borderLeft: 0,
        borderRight: 0,
        borderTop: 0,
      },
    },
    tyc: {
      [theme.breakpoints.up("md")]: {
        position: "relative",
        // bottom: 0,
      },
      "& > p": {
        color: theme.palette.primary.main,
        textAlign: "center",
        letterSpacing: 0,
        fontWeight: "bold",
        [theme.breakpoints.down("xs")]: {
          fontSize: "0.875rem",
        },
        "& a": {
          color: theme.palette.secondary.main,
          textDecoration: "none",
        },
      },
      // [theme.breakpoints.down("md")]: {
      //   marginBottom: "4rem",
      // },
    },
    confirmText: {
      textAlign: "center",
      [theme.breakpoints.up("md")]: {
        textAlign: "left",
        fontSize: "0.875rem",
        lineHeight: "1rem",
      },
    },
  }));
